import React from "react";


const WaveBackground = () => (
  <>
    <svg
      className="wave-bg"
      viewBox="0 0 366 838"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <defs>
        {/* soft glow used by all ellipses */}
        <radialGradient id="waveGlow">
          <stop offset="0%" className="wave-red" stopOpacity="1" />
          <stop offset="30%" className="wave-red" stopOpacity="0.9" />
          <stop offset="100%" className="wave-red" stopOpacity="0" />
        </radialGradient>
      </defs>

      <rect width="366" height="838" className="wave-base" />

      {/* left glow behind the hours card */}
      <ellipse cx="0" cy="345" rx="70" ry="95" fill="url(#waveGlow)" opacity="0.45" />

      {/* lower-right glow */}
      <ellipse cx="372" cy="465" rx="285" ry="215" fill="url(#waveGlow)" opacity="0.88" />

      {/* glow behind the holiday card */}
      <ellipse cx="255" cy="688" rx="150" ry="62" fill="url(#waveGlow)" opacity="0.5" />

      {/* bottom-left glow */}
      <ellipse cx="0" cy="792" rx="200" ry="190" fill="url(#waveGlow)" opacity="0.62" />
    </svg>

    <svg
      className="wave-bg wave-top"
      viewBox="0 0 366 838"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <defs>
        {/* Red builds towards the curved edge, leaving the logo area dark. */}
        <linearGradient
          id="waveBand"
          gradientUnits="userSpaceOnUse"
          x1="120"
          y1="35"
          x2="285"
          y2="145"
        >
          <stop offset="0%" className="wave-red" stopOpacity="0" />
          <stop offset="100%" style={{ stopColor: "color-mix(in srgb, var(--wave-red) 75%, var(--brand-strong))" }} />
        </linearGradient>

        <linearGradient id="waveShadow" x1="100%" y1="0%" x2="45%" y2="100%">
          <stop offset="0%" className="wave-red" />
          <stop offset="100%" className="wave-red" stopOpacity="0" />
        </linearGradient>
      </defs>

      {/* Subtle red shading on the dark side of the curve. */}
      <rect width="366" height="270" fill="url(#waveShadow)" />

      {/* the wave: band with a sharp curved lower edge */}
      <path
        d="M0 0 H366 V32 C300 70 235 115 198 184 C166 240 143 306 128 430 H0 Z"
        fill="url(#waveBand)"
      />
    </svg>
  </>
);

export default WaveBackground;
